import React from "react";
import { Select, Form, Icon, Input, Button, Row, Col, DatePicker } from "antd";
import { withNamespaces } from "react-i18next";
import get from "lodash/get";
import find from "lodash/find";
import lowerCase from "lodash/lowerCase";
import FileLink from "../FileLink/FileLink";
import {capitalize} from "lodash";

const { Option } = Select;


const getActivePersons = (flatPersonSettings) => {
  if (!flatPersonSettings){
    return [];
  }
  const addedPersons = [];
  const outputSettings = [];
  flatPersonSettings.map((setting) => {
    if (setting['person'] && !addedPersons.includes(setting['person'])){
      addedPersons.push(setting['person']);
      outputSettings.push(setting);
    }
  });
  return outputSettings;
};


// TO select consent type and method with 1 select "Ragained capacity electronic"
// const getActiveMethodsAndType = (flatPersonSettings, selectedPerson) => {
//   if (!flatPersonSettings){
//     return [];
//   }
//   const addedMethodsTypes = [];
//   const outputSettings = [];
//   flatPersonSettings.map((setting) => {
//     const methodType = setting['type'] + '__' + setting['method'];
//     if (capitalize(setting['person']) ===  selectedPerson && !addedMethodsTypes.includes(methodType)){
//       addedMethodsTypes.push(methodType);
//       outputSettings.push(setting);
//     }
//   });
//   return outputSettings;
// };


const getActiveLangCodes = (flatPersonSettings, selectedPerson, selectedType, selectedMethod) => {
  if (!flatPersonSettings){
    return [];
  }

  const addedLangCodes = [];
  flatPersonSettings.map((setting) => {
    if (capitalize(setting['person']) ===  selectedPerson && setting['method'] ===  selectedMethod && setting['type'] ===  selectedType && !addedLangCodes.includes(setting['language_code'])){
      addedLangCodes.push(setting['language_code']);
    }
  });
  return addedLangCodes;
};

const getActiveLangCodesByMethodType = (flatPersonSettings, selectedPerson, selectedMethodType) => {
  if (!flatPersonSettings){
    return [];
  }
  const splitType = selectedMethodType.split("__");
  const selectedType = splitType[0];
  const selectedMethod = splitType[1];
  return getActiveLangCodes(flatPersonSettings, selectedPerson, selectedType, selectedMethod);
  };


// to select type and method separately via 2 selects "Ragained capacity" and  "electronic" in another select
const getActiveTypes = (flatPersonSettings, selectedPerson) => {
  if (!flatPersonSettings){
    return [];
  }
  const addedTypes = [];
  const outputSettings = [];
  const settingActiveStates = {};
  flatPersonSettings.map((setting) => {
    if (!get(settingActiveStates, setting['type']) && get(setting, 'active')){
      settingActiveStates[setting['type']] = true;
    }
    if (capitalize(setting['person']) ===  selectedPerson && !addedTypes.includes(setting['type'])){
      addedTypes.push(setting['type']);
      outputSettings.push({
        'type': setting['type'],
        'label': get(setting, 'type_label'),
        'active': get(setting, 'active'),
      });
    }
  });
  // fix active in settings
  outputSettings.map((outSetting) => {
    outSetting['active'] = get(settingActiveStates, outSetting['type'], false);
  });
  return outputSettings;
};

// to select type and method separately via 2 selects "Ragained capacity" and  "electronic" in another select
const getActiveMethods = (flatPersonSettings, selectedPerson, selectedType) => {
  if (!flatPersonSettings){
    return [];
  }
  const outputSettings = [];

  const addedMethods = [];
  flatPersonSettings.map((setting) => {
    if (capitalize(setting['person']) ===  selectedPerson && setting['type'] ===  selectedType && !addedMethods.includes(setting['method'])){
      addedMethods.push(setting['method']);
      outputSettings.push({
        'method': setting['method'],
        'methodType': setting['type'] + '__' + setting['method'],
        'label': capitalize(setting['method']),
        'active': get(setting, 'active'),
      });
    }
  });
  return outputSettings;
};



const ConsentStep2 = (props) => {
  let consentPersonType = props.form.getFieldValue("consentPersonType") || '';
  let consentMethodType = props.form.getFieldValue("consentMethodType") || '';


  const splitType = consentMethodType.split("__");
  const consentType = splitType[0];
  const consentMethod = splitType[1];

  let personInitial = null;
  let methodInitial = null;
  let typeInitial = null;
  let typeWithMethodInitial = null;
  
  if (get(props, 'flat_person_settings') && get(props, 'suggested_next_consent_type')){
    props['flat_person_settings'].map((setting) => {
      if (setting['active'] ===  true && props.suggested_next_consent_type['type'] == setting['type'] && props.suggested_next_consent_type['method'] == setting['method']){
        personInitial = capitalize(setting['person']);
        methodInitial = capitalize(setting['method']);
        typeInitial = setting['type'];
        methodInitial = setting['method'];
        typeWithMethodInitial = setting['type'] + '__' + setting['method'];
      }
    });
  }

  //BASED ON FLAT
  let possibleLanguageCodes = getActiveLangCodesByMethodType(props.flat_person_settings, consentPersonType, consentMethodType);

  return (
    <div className="form-group">
      <div className="form-group-details">
        {props.subjectID ? <h4>
          {props.i18n.t(
            "NamespaceConsent:Subject Found! Please verify details below"
          )}
          :
        </h4> : <h4>
          {props.i18n.t(
            "NamespaceConsent:Please verify details below"
          )}
          :
        </h4>}
        {props.siteID && (
          <h5>
            {props.i18n.t("NamespaceConsent:Site ID")}: <b>{props.siteID}</b>
          </h5>
        )}
        {props.userID && (
          <h5>
            {props.i18n.t("NamespaceConsent:User ID")}: <b>{props.userID}</b>
          </h5>
        )}
        <h5>
          {props.i18n.t("NamespaceConsent:Subject ID")}: <b>{props.subjectID}</b>
        </h5>

        <h5>
          {props.i18n.t("NamespaceConsent:Consent Exists")}:{" "}
          <b>{props.consentExists === true ? "Yes" : "No"}</b>
        </h5>

        {props.consentExists && (
          <div className="consent-exists">
            <h5>
              {props.i18n.t("NamespaceConsent:Consent Date")}: <b>{props.consentExistsDate}</b>
            </h5>
            <h5>
              {props.i18n.t("NamespaceConsent:Consent Type")}: <b>{props.consentExistsType}</b>
            </h5>
            <h5>
              {props.i18n.t("NamespaceConsent:Consent Person")}:{" "}
              <b>{props.consentExistsPersonType}</b>
            </h5>
            <h5>
              {props.i18n.t("NamespaceConsent:Consent Method")}:{" "}
              <b>{props.consentExistsMethodType}   {props.consent_upload_later && <span>({props.i18n.t("NamespaceConsent:uploading skipped")})</span>}</b>
            </h5>

            {props.consentExistsMethodType && props.consentExistsMethodType.includes('Email') &&
              props.consentExistsEmailStatus && (
                <h5>
                  {props.i18n.t(
                    "NamespaceConsent:Consent Email Status"
                  )}
                  : <b>{props.consentExistsEmailStatus.replace(/_/g, " ")}</b>
                </h5>
              )}

            {props.consentExistsLink &&
              (Array.isArray(props.consentExistsLink) ? (
                props.consentExistsLink.map(({ link, name }) => (
                  <h5 key={name}>
                    {props.i18n.t("NamespaceConsent:Document Link")}:{" "}
                    <b style={{ position: "relative", top: "8px" }}>
                      <FileLink url={link} text={name} />
                    </b>
                  </h5>
                ))
              ) : (
                <h5>
                  {props.i18n.t("NamespaceConsent:Document Link")}:{" "}
                  <b>
                    <a href={props.consentExistsLink.link} target="_blank">
                      {props.consentExistsLink.name}
                    </a>
                  </b>
                </h5>
              ))}
          </div>
        )}
      </div>
      {props.consent_upload_later &&
        <div className='ant-alert ant-alert-error'>
          <p>{props.i18n.t("Warning:")}{" "}{props.i18n.t('NamespaceConsent:Paper Consent file has not been uploaded. Please upload this file from the workflow below prior to initiating another consent workflow for this subject!')}</p>
        </div>
      }
      {/*//BASED ON FLAT*/}
      {(props.flat_person_settings) &&
        <Form.Item>
          <label>
            <span className="form-label">
              {props.i18n.t(
                "NamespaceConsent:Who will be providing Consent?"
              )}
            </span>
            {props.form.getFieldDecorator("consentPersonType", {
              initialValue: personInitial,
              rules: [
                {
                  required: true,
                  message: props.i18n.t(
                    "NamespaceConsent:Please select who will be providing consent"
                  ),
                },
              ],
            })(
               <Select>
                 {
                   getActivePersons(props.flat_person_settings).map(function(personVal, index) {
                     return <Option key={index} value={capitalize(get(personVal, 'person', ''))} disabled={!get(personVal, 'person_active')}>
                          {capitalize(get(personVal, 'person', ''))}
                        </Option>;
                    })
                 }
              </Select>
            )}
          </label>
        </Form.Item>
      }

      {/*// TO select consent type and method with 1 select "Ragained capacity electronic"*/}
     {/*{(props.flat_person_settings) &&*/}
     {/* <Form.Item>*/}
     {/*   <label>*/}
     {/*     <span className="form-label">{props.i18n.t("NamespaceConsent:Consent Type")}</span>*/}
     {/*     {props.form.getFieldDecorator("consentMethodType", {*/}
     {/*       initialValue: typeWithMethodInitial,*/}
     {/*       rules: [*/}
     {/*         {*/}
     {/*           required: true,*/}
     {/*           message: props.i18n.t(*/}
     {/*             "NamespaceConsent:Please select the type of consent desired"*/}
     {/*           ),*/}
     {/*         },*/}
     {/*       ],*/}
     {/*     })(*/}
     {/*       <Select>*/}
     {/*           {*/}
     {/*              getActiveMethodsAndType(props.flat_person_settings, props.form.getFieldValue("consentPersonType") || '').map(function(settingVal, index) {*/}
     {/*                return <Option key={index} value={settingVal['type'] + '__' + settingVal['method']} disabled={!get(settingVal, 'active')}>*/}
     {/*                     {capitalize(get(settingVal, 'label'))}*/}
     {/*                   </Option>;*/}
     {/*               })*/}
     {/*            }*/}

     {/*       </Select>*/}
     {/*     )}*/}
     {/*   </label>*/}
     {/* </Form.Item>*/}
     {/* }*/}

      {(props.flat_person_settings) &&
        <Form.Item>
          <label>
            <span className="form-label">{props.i18n.t("NamespaceConsent:Consent Type")}</span>
            {props.form.getFieldDecorator("consentType", {
              initialValue: typeInitial,
              rules: [
                {
                  required: true,
                  message: props.i18n.t(
                    "NamespaceConsent:Please select the type of consent desired"
                  ),
                },
              ],
            })(
              <Select>
                  {
                     getActiveTypes(props.flat_person_settings, props.form.getFieldValue("consentPersonType") || '').map(function(settingVal, index) {
                       return <Option key={index} value={settingVal['type']} disabled={!get(settingVal, 'active')}>
                            {capitalize(get(settingVal, 'label'))}
                          </Option>;
                      })
                   }

              </Select>
            )}
          </label>
        </Form.Item>
      }

      {(props.flat_person_settings) &&
        <Form.Item>
          <label>
            <span className="form-label">{props.i18n.t("NamespaceConsent:Consent Method")}</span>
            {props.form.getFieldDecorator("consentMethodType", {
              rules: [
                {
                  required: true,
                  message: props.i18n.t(
                    "NamespaceConsent:Please select consent collection method"
                  ),
                },
              ],
            })(
              <Select>
                  {
                     getActiveMethods(props.flat_person_settings, props.form.getFieldValue("consentPersonType") || '', props.form.getFieldValue("consentType") || '').map(function(settingVal, index) {
                       return <Option key={index} value={settingVal['methodType']} disabled={!get(settingVal, 'active')}>
                            {capitalize(get(settingVal, 'label'))}
                          </Option>;
                      })
                   }

              </Select>
            )}
          </label>
        </Form.Item>
      }


      {(props.flat_person_settings && possibleLanguageCodes && possibleLanguageCodes.length > 1) &&
        <Form.Item>
          <label>
            <span className="form-label">
              {props.i18n.t(
                "NamespaceConsent:Consent Language?"
              )}
            </span>
            {props.form.getFieldDecorator("languageCode", {
              // initialValue: props.consentPersonType || props.consentExistsPersonType,
              rules: [
                {
                  required: true,
                  message: props.i18n.t(
                    "NamespaceConsent:Please select a language in which the consent will be provided"
                  ),
                },
              ],
            })(
               <Select>
                 {
                   possibleLanguageCodes.map(function(languageCode, index) {
                     return <Option key={index} value={languageCode}>
                          {capitalize(languageCode)}
                        </Option>;
                    })
                 }

              </Select>
            )}
          </label>
        </Form.Item>
      }

      {
      <Form.Item>
        <label>
          <span className="form-label">{props.i18n.t("NamespaceConsent:Who is collecting the consent?")}</span>
          {props.form.getFieldDecorator("who_is_collecting_consent", {
            // initialValue: props.consentExistsMethodType,
            rules: [
              {
                required: true,
                message: props.i18n.t(
                  props.i18n.t("Required")
                ),
              },
            ],
          })(
            <Select>
              <Option value="investigator">
                            {props.i18n.t("NamespaceConsent:Investigator")}</Option>
              <Option value="other">{props.i18n.t("NamespaceConsent:Other role")}</Option>
            </Select>
          )}
        </label>
      </Form.Item>
      }

      <Form.Item>
        <label>
          <span className="form-label">
            {props.i18n.t(
              "NamespaceConsent:Please indicate approval to start the consenting process"
            )}
          </span>
          {props.form.getFieldDecorator("consent_overwrite", {
            rules: [
              {
                required: true,
                message: props.i18n.t(
                  "NamespaceConsent:You need to agree to override data if you wish to proceed with this entry!"
                ),
              },
            ],
          })(
            <Select>
              <Option value="yes">{props.i18n.t("Yes")}</Option>
              <Option value="">{props.i18n.t("No")}</Option>
            </Select>
          )}
        </label>
      </Form.Item>
    </div>
  );
};

export default withNamespaces()(ConsentStep2);



// WEBPACK FOOTER //
// ./src/components/ConsentTypeWorkflowV2_1/ConsentStep2.js